module.exports = __webpack_public_path__ + "img/设计图片示例3.1a3e84bb.png";